import React from 'react';

import { EdgeShadowsOverlay } from '../../components/backdrops/EdgeShadowsOverlay';

type ScrollingMarqueeListProps<T> = {
  items: T[];
  renderItem: (item: T) => React.ReactNode;
};
function ScrollingMarqueeList<T>(props: ScrollingMarqueeListProps<T>) {
  const { items, renderItem } = props;
  const repeated = [...items, ...items, ...items, ...items];
  return (
    <EdgeShadowsOverlay className="flex" shadowHeight={200} shadowWidth={200}>
      <div className="py-4 whitespace-nowrap flex items-center animate-marqueeToLeft">
        {repeated.map((item, index) => (
          <React.Fragment key={index}>{renderItem(item)}</React.Fragment>
        ))}
      </div>
    </EdgeShadowsOverlay>
  );
}
ScrollingMarqueeList.displayName = 'ScrollingMarqueeList';
export default ScrollingMarqueeList;
